import styled from 'styled-components'

interface IModal {
  noBackground?: boolean;
  width?: string;
  alignButtons?: string;
  gap?: boolean;
}

export const Modal = styled.div<IModal>`
  display: flex;
  justify-content: center;
  align-items: center;
  
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;

  user-select: none;

  width: 100%;
  height: 100vh;
  background-color: ${ ({noBackground}) => noBackground && 'rgba(33,37,41,0.4)' }; 

  .container{
    display: flex;
    flex-flow: column;
    justify-content: center;

    width: ${({ width }) => width || '420px'};
    height: auto;
    padding: 23px;
    border-radius: 10px;
    background-color: #FFF;
    box-sizing: border-box;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.11);

    .image{
      display: flex;
      justify-content: center;

      margin-bottom: 28px;

      img{
        height: 120px;
      }
    }

    .message {
      text-align: center;
      color:rgba(54, 72, 99, 1);
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 28px;  
      line-height: 1.5;    
    }

    .buttons {
      display: flex;
      justify-content: ${({ alignButtons }) => alignButtons || 'space-between'};
      gap: ${({ gap }) => gap && '16px'};
      margin-top: 16px;

      width: 100%;

      .btnYes, .btnNo{
        width: 48%;
      }
    }
  }
` 